import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Pagination from '@bibliocommons/pagination';

import './ShelfBottomControls.scss';

export default function ShelfBottomControls({ isFetching, pagination }) {
  return (
    <section className="cp-shelf-bottom-controls">
      <Pagination showFirstPage showLastPage isFetching={isFetching} pagination={pagination} />
    </section>
  );
}

ShelfBottomControls.propTypes = {
  isFetching: PropTypes.bool,
  pagination: ImmutablePropTypes.map.isRequired
};
